export { Point, doOverlap }


class Point {

    constructor(val) {
        this.x = val;
        this.y = val;
    }
}

// Returns true if two rectangles
// (l1, r1) and (l2, r2) overlap
function doOverlap(l1, r1, l2, r2) {

    // To check if either rectangle is actually a line
    // For example : l1 ={-1,0} r1={1,1} l2={0,-1} r2={0,1}

    if (l1.x == r1.x || l1.y == r1.y ||
        l2.x == r2.x || l2.y == r2.y) {
        // the line cannot have positive overlap

        // console.log(":: line cannot have positive overlap        ")
        return false;
    }

    // If one rectangle is on left side of other
    if (l1.x >= r2.x || l2.x >= r1.x) {
        // console.log(":: one rectangle is on left side of other")
        return false;
    }

    // If one rectangle is above other
    if (r1.y >= l2.y || r2.y >= l1.y) {
        // console.log("::one rectangle is above other")
        return false;
    }

    return true;
}